import React, { FC, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PageHeading, Button } from 'src/common';
import { faBookOpen, faEnvelope } from '@fortawesome/pro-light-svg-icons';
import styles from './index.module.scss';
import { GenerateInbox } from 'src/shared';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FeatureFlag, useFeatureFlag } from 'src/helpers/featureFlag';

interface IProps {}
export const CallOffsStart: FC<IProps> = () => {
  const { t, i18n } = useTranslation();
  const isKnowledgeBankFeature = useFeatureFlag(FeatureFlag.KnowledgeBank);

  const [createInboxVisible, setCreateInboxVisible] = useState(false);
  const onOpen = useCallback(() => {
    setCreateInboxVisible(true);
  }, []);
  const onClose = useCallback(() => {
    setCreateInboxVisible(false);
  }, []);

  return (
    <>
      <PageHeading
        icon={faEnvelope}
        title={t('CallOffs.frameworkAgreementCallOfs')}
        desc={t('CallOffs.callOffsPageDesc')}
      />
      {isKnowledgeBankFeature && (
        <a
          href={`${import.meta.env.VITE_HELPDOCS_DOMAIN}${i18n.language}/article/xz1v6ctgz7-avropshantering`}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.link}
        >
          <FontAwesomeIcon icon={faBookOpen} />
          <span>{t('CallOffs.learnMoreAboutCallOffs')}</span>
        </a>
      )}
      <div className={styles.actions}>
        <Button className={styles.button} onClick={onOpen} type={'primary'}>
          {t('CallOffs.getStarted')}
        </Button>
      </div>
      {createInboxVisible && <GenerateInbox onClose={onClose} />}
    </>
  );
};

export default CallOffsStart;
